var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BIT-Main",
    width: 73.616,
    height: 73.616,
    viewBox: "0 0 73.616 73.616",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: #262262;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 33.84,
    x2: 23.65,
    y1: 34.32,
    y2: 64.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262262",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204072",
    offset: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186888",
    offset: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#128899",
    offset: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e9ea5",
    offset: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0bacac",
    offset: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0bb1af",
    offset: 0.66
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 60.47,
    x2: 35.64,
    y1: 52.29,
    y2: 34.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcb05",
    offset: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9c607",
    offset: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eabb0d",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1a718",
    offset: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ae8c27",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81693a",
    offset: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4c3f51",
    offset: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262262",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 35.13,
    x2: 60.81,
    y1: 31.94,
    y2: 13.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262262",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#452c5a",
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#964746",
    offset: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f26531",
    offset: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 24.14,
    x2: 33.58,
    y1: 1.63,
    y2: 31.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a053a0",
    offset: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76428b",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#533479",
    offset: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3a2a6c",
    offset: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b2464",
    offset: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262262",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 32.13,
    x2: 1.25,
    y1: 33.03,
    y2: 32.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262262",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263978",
    offset: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26619d",
    offset: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2681ba",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2697cf",
    offset: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26a5dc",
    offset: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27aae1",
    offset: 0.66
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.7669 3.9278)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.62 55.63-0.14-0.45c-0.04-0.14-0.08-0.27-0.13-0.41l-1-3.23c-0.4-1.29-0.61-2.63-0.58-3.98 0.06-2.61 0.48-5.22 1.24-7.75l1.57-5.22-1.99-0.66-1.84 5.07c-0.91 2.55-2.17 4.96-3.71 7.15-0.75 1.06-1.68 1.98-2.73 2.74l-2.11 1.55c-1.62 0.91-2.93 2.41-3.56 4.32-1.34 4.06 0.87 8.44 4.93 9.78s8.44-0.87 9.78-4.93c0.44-1.34 0.49-2.7 0.22-3.99h0.04z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m59.25 41.78c-1.13-0.83-2.42-1.3-3.72-1.44l0.02-0.03h-0.48c-0.14-0.01-0.28-0.01-0.42-0.01l-3.39-0.04c-1.35-0.02-2.69-0.23-3.96-0.68-2.46-0.87-4.81-2.07-6.98-3.58l-4.5-3.12-1.24 1.71 4.27 3.31c2.15 1.66 4.05 3.59 5.65 5.74 0.78 1.04 1.36 2.21 1.77 3.44l0.82 2.49c0.37 1.83 1.38 3.53 3.01 4.72 3.45 2.53 8.3 1.78 10.82-1.67 2.53-3.45 1.78-8.3-1.67-10.82z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m61.11 13.43c-2.5-3.47-7.34-4.26-10.81-1.76-1.14 0.82-1.98 1.9-2.52 3.09l-0.02-0.03-0.15 0.45c-0.05 0.13-0.09 0.27-0.14 0.4l-1.09 3.2c-0.43 1.28-1.05 2.49-1.87 3.56-1.58 2.07-3.46 3.94-5.56 5.54l-4.35 3.29 1.22 1.71 4.48-3.01c2.24-1.53 4.67-2.74 7.21-3.6 1.23-0.42 2.52-0.61 3.82-0.62h2.62c1.85 0.2 3.78-0.24 5.41-1.41 3.47-2.5 4.26-7.34 1.76-10.81z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m33.18 26c-0.76-2.6-1.16-5.29-1.2-7.97-0.02-1.3 0.2-2.59 0.59-3.82l0.8-2.49c0.78-1.69 0.95-3.67 0.34-5.58-1.31-4.07-5.67-6.32-9.74-5.01s-6.32 5.67-5.01 9.74c0.43 1.34 1.19 2.47 2.16 3.36h-0.04l0.38 0.3c0.11 0.09 0.23 0.17 0.34 0.26l2.71 2.02c1.08 0.81 2.04 1.77 2.81 2.88 1.48 2.15 2.68 4.5 3.55 7l1.73 5.13 2-0.63-1.43-5.17z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m27.21 31.68c-2.71-0.08-5.39-0.53-7.95-1.32-1.24-0.39-2.4-0.99-3.45-1.75l-2.12-1.53c-1.37-1.26-3.19-2.04-5.2-2.05-4.28-0.02-7.76 3.44-7.78 7.71-0.02 4.28 3.44 7.76 7.71 7.78 1.41 0 2.72-0.37 3.86-1.02v0.04l0.39-0.27c0.12-0.08 0.23-0.16 0.35-0.24l2.76-1.95c1.1-0.78 2.31-1.4 3.6-1.78 2.5-0.74 5.11-1.15 7.75-1.21l5.46-0.16 0.01-2.11-5.39-0.13z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.858 35.492c1.0195-0.32834 1.8892-1.539 1.8933-2.611 0.0041-1.0721-0.84686-2.2761-1.8628-2.611-1.0159-0.33485-2.4216 0.12658-3.0538 0.99248s-0.6398 2.3523-0.01527 3.2217c0.62453 0.86941 2.019 1.3361 3.0385 1.0077z",
    fill: "#262262",
    strokeWidth: "0px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplat);
export default __webpack_public_path__ + "static/media/splat.48094f0a7aec15fada0e0c7c72a287ee.svg";
export { ForwardRef as ReactComponent };